import { jsx } from 'react/jsx-runtime';
import SvgBrazil from '../../../assets/icons/brazil.svg.js';
import SvgSpain from '../../../assets/icons/spain.svg.js';
import SvgUnitedStates from '../../../assets/icons/united-states.svg.js';
import 'react';

const Icon = ({
  idLanguage
}) => {
  const propsIcon = {
    width: 24,
    height: 24
  };
  if (idLanguage === "PT_BR") {
    return /* @__PURE__ */ jsx(SvgBrazil, { ...propsIcon });
  }
  if (idLanguage === "EN") {
    return /* @__PURE__ */ jsx(SvgUnitedStates, { ...propsIcon });
  }
  return /* @__PURE__ */ jsx(SvgSpain, { ...propsIcon });
};

export { Icon };
